import Slider from "react-slick";
import { Link } from "@mui/material";
import { useSearch, useQuery, useSearchContext } from "@sajari/react-hooks";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";
import styled from "styled-components";

import "./style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../../../../../styles/common.css";
import "../../../../../styles/responsive-common.css";

const Banner = ({ data }: any) => {
  const history = useHistory();
  const { results = [] } = useSearch();
  const { query, setQuery } = useQuery();
  const { searched } = useSearchContext();

  var settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: true,
    nextArrow: <FontAwesomeIcon size="10x" icon={faChevronRight} />,
    prevArrow: <FontAwesomeIcon size="10x" icon={faChevronLeft} />,
  };

  const handleChangeCategory = (category: any) => {
    setQuery(category);
    history.push({
      pathname: "/search-results",
      search: `?${"q"}=${category}`,
      state: {
        searched: searched,
        results: results,
      },
    });
  };

  return (
    <SliderWrapper className="top-banner">
      <title>Paysfer eMart</title>
      <meta
        name="description"
        content="Online marketplace sells all categories of goods since 2020, NY based. Multi-vendor,new platform, custom Seller shops. Low seller fees, lower prices, shipping"
      />

      <Slider {...settings}>
        {data.images.map((item: any, index: number) => (
          <Link key={index} onClick={() => handleChangeCategory(item.category)}>
            <SliderImg alt="home-banner11" src={item.src} />
          </Link>
        ))}
      </Slider>
    </SliderWrapper>
  );
};

const SliderImg = styled.img`
  display: block;
  height: 234px;
  width: 100vw;
  object-fit: fill;
`;

const SliderWrapper = styled.div`
  height: 234px;
  width: 100vw;
  padding: 0;
  overflow: hidden;
  isolation: isolate;
  margin: 0 auto;
`;

export default Banner;
